module.exports = __webpack_public_path__ + "img/7.92059a38.jpg";